import React, { useEffect, useState } from "react"
import cn from "classnames"
import BeatCard from "./BeatCard"
import css from "./Beats.module.scss"

export default function Beats({ playingBeat, setPlayingBeat, beats, bonusBeat, stop }) {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  return (
    <div className={cn(css.beatsWrapper, isLoaded && css.beatsWrapper__visible)}>
      {beats.map((beat) => (
        <BeatCard key={beat.id} beat={beat} playingBeat={playingBeat} setPlayingBeat={setPlayingBeat} />
      ))}
      <BeatCard beat={bonusBeat} playingBeat={playingBeat} setPlayingBeat={setPlayingBeat} />
      <BeatCard stop={stop} />
    </div>
  )
}
